import React, { useState } from 'react';
import {
  alpha,
  Card,
  Stack,
  Tooltip,
  Collapse,
  Checkbox,
  useTheme,
  useMediaQuery,
  CardHeader,
  Typography,
  IconButton,
  CardContent,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Form from './Form';
import { ExpandMoreButton } from 'components';
import { FormattedMessage } from 'react-intl';
import { digitsEnToFa } from '@persian-tools/persian-tools';
import { FilterAltOffRounded, KeyboardArrowUpRounded } from '@mui/icons-material';
import { useSelector } from 'react-redux';

import { TariffSelectionWidget } from 'components/FormWidgets';
import { TariffModel } from 'models';
import DownloadTasks from './DownloadTasks';
import DownloadTaskVehicles from './DownloadTaskVehicles';
import DownloadTaskSupervisors from './DownloadTaskSupervisors';
import { hasRequiredRole } from 'helpers';

export default function Filter({
  init,
  total,
  loading,
  refetch,
  isPopup,
  selection,
  acception,
  setFilter,
  clearFilter,
  clearSelection,
  handleSelectAllClick,
  desktopActions,
}) {
  const theme = useTheme();
  const [title, setTitle] = useState('');
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { defaultMatches: false });

  const {
    language: { direction },
  } = useSelector((state) => state.setting);
  const { isAuthenticated, userInfo } = useSelector((state) => state.auth);

  const [formKey, setFormKey] = useState(0);

  const handleClearFilter = () => {
    setTitle('');
    setFormKey((key) => key + 1);
    clearFilter();
  };

  const handleExpandClick = () => setExpanded(!expanded);

  const filterCount = digitsEnToFa(
    Object.values(init)
      .map((val) => {
        if (typeof val === 'object') {
          return Boolean(val.length);
        } else {
          return Boolean(val);
        }
      })
      .filter((val) => val).length
  );

  const onAssign = (data, onClose) => {
    const tariff = data[0];
    setTitle(tariff?.title);
    setFilter({
      site_ids: tariff?.site_id,
      workshop_ids: tariff?.workshop_id,
      material_type_ids: tariff?.material_type_id,
      shift_type_ids: tariff?.shift_type_id,
      operation_type_ids: tariff?.operation_type_id,
    });
    onClose();
  };

  const clearTariff = () => {
    setTitle('');
    setFilter({});
  };

  return (
    <>
      <Card
        elevation={1}
        sx={{
          direction: { direction },
          // bgcolor: selection ? alpha(theme.palette.warning.light, 1) : alpha(theme.palette.background.paper, 1),
        }}
      >
        <CardHeader
          onClick={handleExpandClick}
          title={
            <Typography variant="subtitle1" fontSize={14}>
              <FormattedMessage
                id={selection > 0 ? 'selected' : 'selectAll'}
                values={{ selected: digitsEnToFa(selection) }}
              />
            </Typography>
          }
          sx={{ p: 1, cursor: 'pointer' }}
          subheader={
            <Typography fontSize={12} variant="subtitle2">
              <FormattedMessage id="filtered" values={{ filtered: filterCount }} />
            </Typography>
          }
          avatar={
            <Checkbox
              size="small"
              color="warning"
              indeterminate={selection > 0 && selection < acception}
              checked={acception > 0 && selection === acception}
              onClick={(e) => e.stopPropagation()}
              onChange={handleSelectAllClick}
            />
          }
          action={
            <Stack
              columnGap={0.5}
              rowGap={0.5}
              direction="row"
              flexWrap="wrap"
              alignItems="center"
              justifyContent="flex-end"
              onClick={(e) => e.stopPropagation()}
            >
              {!isMobile && desktopActions && (
                <Stack direction="row" spacing={1} sx={{ mx: 1 }}>
                  {desktopActions}
                </Stack>
              )}
              {isAuthenticated && hasRequiredRole(['driver'], userInfo?.roles) ? (
                <></>
              ) : (
                <>
                  <DownloadTaskVehicles filter={init} setExpanded={setExpanded} />
                  <DownloadTaskSupervisors filter={init} setExpanded={setExpanded} />
                  <DownloadTasks filter={init} setExpanded={setExpanded} />
                </>
              )}
              {title && (
                <Stack p={1} zIndex={2} alignItems="center" justifyContent="center">
                  <IconButton
                    color="error"
                    onClick={clearTariff}
                    sx={{ width: 24, height: 24, fontSize: 16, bgcolor: 'error.lighter' }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                </Stack>
              )}

              <Tooltip title={<FormattedMessage id="rmFilters" />}>
                <IconButton sx={{ bgcolor: 'info.lighter' }} size="small" color="info" onClick={handleClearFilter}>
                  <FilterAltOffRounded color="info" fontSize="small" />
                </IconButton>
              </Tooltip>
              <ExpandMoreButton
                open={<FormattedMessage id="showFilters" />}
                close={<FormattedMessage id="hideFilters" />}
                onClick={handleExpandClick}
                expand={expanded}
              >
                <KeyboardArrowUpRounded color="warning" fontSize="small" />
              </ExpandMoreButton>
            </Stack>
          }
        />
        <Collapse in={expanded} timeout="auto">
          <CardContent
            sx={{
              py: 0,
              px: 1,
              '& .MuiInputLabel-root': { fontSize: 13 },
              '& .MuiInputLabel-root.MuiInputLabel-shrink': { fontSize: 12 },
              '& .MuiFormLabel-root': { fontSize: 13 },
              '& .MuiFormControlLabel-label': { fontSize: 13 },
              '& .MuiTypography-subtitle1': { fontSize: 13 },
            }}>
            <Form key={formKey} init={init} setFilter={setFilter} />
            {/* <TariffSelectionWidget /> */}
          </CardContent>
        </Collapse>
      </Card>
    </>
  );
}
